import type {SkipToken} from '@reduxjs/toolkit/query'
import {skipToken} from '@reduxjs/toolkit/query'
import {createContext} from 'react'

import type {GetCleanupRulesArg} from '../../../services/rest'
import {ROOT_PROJECT_ID} from '../../../types'

export const ProjectIdContext = createContext(ROOT_PROJECT_ID)
export const GetRulesArgContext = createContext<GetCleanupRulesArg | SkipToken>(skipToken)
